const btnTypeClassName = (type) => {
    switch (type) {
        case 'secondary':
            return 'btn--secondary';
        case 'tertiary':
            return 'btn--tertiary';
        case 'tertiaryWithIcon':
            return 'btn--tertiary-icon';
        default:
            return '';
    }
};
export { btnTypeClassName };
